import { render, staticRenderFns } from "./TutorAssignmentForm.vue?vue&type=template&id=67a0b278"
import script from "./TutorAssignmentForm.vue?vue&type=script&lang=js"
export * from "./TutorAssignmentForm.vue?vue&type=script&lang=js"
import style0 from "./TutorAssignmentForm.vue?vue&type=style&index=0&id=67a0b278&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports